import { LocalStorage } from "./localStorage";

class TourDCStorage extends LocalStorage {
	public constructor() {
		super({
			storageKey: "tour_dc",
		});
	}
}

export const tourDCStorage = new TourDCStorage();
